import React, { Component } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Route } from 'react-router-dom'
// components
import Navbar from './components/navbar'
import Home from './components/Home'
import Task from './components/Task'
import Dashboard from './components/Dashboard'
import Class from './components/Class'
import Textbooks from './components/Textbooks'
import SpellingBee from './components/SpellingBee'
import FlashcardMaster from './components/FlashcardMaster'
import Record from './components/Record'
import LoginForm from './components/login-form'
import ContactForm from './components/ContactForm'
import Signup from './components/sign-up'
import Help from './components/help'

function Farewell({ name }) {
  //throw new Error('Crashed !@ render'); 
  const uName = name.toUpperCase();
  //return <div>Goodbye {name.toUpperCase()}</div>
  return null;
}

function ErrorFallback({ error }) {
  return (
    <div role="alert">
      <p>Caught error as below:</p>
      <pre style={{ color: 'red' }}>{[error.name, ': ', error.message]}</pre>
    </div>
  )
}

class App extends Component {
  constructor() {
    super()
    this.handleClick = this.handleClick.bind(this)
    const user = JSON.parse(sessionStorage.getItem('user'));
    this.state = {
      loggedIn: user ? true : false,
      username: user ? user.username : null,
      isTeacher: (user && user.isTeacher) ? true : false,
      isContacted: false,
    }
  }

  handleClick() {
    this.setState(prevState => ({
      isContacted: !prevState.isContacted
    }));
    //console.log("dft isContacted: ", this.state.isContacted)
  }

  render() {
    let loginMode = 'not';  // default, 3 values
    if (this.state.isTeacher == true) loginMode = "teacher";
    else if (this.state.loggedIn == true) loginMode = "student";

    const level = localStorage.getItem(this.state.username)
    let stars = "&#10027;"  // ✫
    if (level == "high") stars = "✫✫✫"
    else if (level == "mid") stars = "✫✫"
    else {
      stars = "✫"
    }

    return (
      <div className="App">
        <Navbar loginMode={loginMode} />

        {(this.state.loggedIn === true) && 
          <label className="label is-normal has-text-success is-size-7 has-text-right">Welcome {this.state.username} @ {stars} &nbsp;&nbsp;&nbsp;&nbsp;</label>
        }
        { (this.state.loggedIn === false) &&
          <label className="label is-normal has-text-success is-size-7 has-text-right">Please Login&nbsp;&nbsp;&nbsp;&nbsp;</label>
        }

        <ErrorBoundary FallbackComponent={ErrorFallback}>

          {this.state.isTeacher && !this.state.isContacted &&(
            <React.Fragment>
              <Route exact path="/" component={Home} />
              <Route path="/textbooks" component={Textbooks} />
              <Route path="/classes" component={Class} />
              <Route path="/task" component={Task} />
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/signup" component={Signup} />
              <Route path="/record" component={Record} />
              <Route path="/spellingbee" component={SpellingBee} />
              <Route path="/flashcardmaster" component={FlashcardMaster} />
              <Route exact path="/help" component={Help} />
              <Route exact path="/contact" component={ContactForm} />
            </React.Fragment>
          )}
          {this.state.loggedIn && !this.state.isTeacher && !this.state.isContacted && (
            <React.Fragment>
              <Route exact path="/" component={Home} />
              <Route path="/task" component={Task} />              
              <Route path="/dashboard" component={Dashboard} />
              <Route path="/signup" component={Signup} />
              <Route path="/record" component={Record} />
              <Route path="/spellingbee" component={SpellingBee} />
              <Route path="/flashcardmaster" component={FlashcardMaster} />
              <Route exact path="/help" component={Help} />
              <Route exact path="/contact" component={ContactForm} />
            </React.Fragment>
          )}
          {!this.state.loggedIn && !this.state.isContacted &&(
            <React.Fragment>
              <Route exact path="/" component={Home} />
              <Route path="/login" component={LoginForm} />
              <Route path="/signup" component={Signup} />
              <Route exact path="/help" component={Help} />
              <Route exact path="/contact" component={ContactForm} />
            </React.Fragment>
          )}

          { this.state.isContacted && < ContactForm  /> }


          {/*
          { this.state.isContacted && <  Route exact path="/contact" component={ContactForm}  /> }
          { this.state.isContacted && (
            <React.Fragment>
              <Route exact path="/contact" component={ContactForm} />
            </React.Fragment>
          )}
          */}


          <p className="center-container" style={{ color: 'blue' }}> Copyright©2026 FiveStar Vocab</p>
          <p  className="center-container">
            <a href="/about-us.pdf">About Us &nbsp;&nbsp;&nbsp;</a>
            <a onClick={this.handleClick} >Email Contact</a>
            <a href="/Wechat-Contact.pdf">&nbsp;&nbsp;&nbsp; Wechat Contact</a>
          </p>
          <br></br>

          <Farewell name='Jay' />
        </ErrorBoundary>

      </div>
    );
  }
}

export default App;